module.exports = __webpack_public_path__ + "static/media/only-c6-logo.4457ccf8.svg";